<template>
  <div class="success-container">
    <div class="success-box">
      <img :src="require('@/assets/images/carry/pic_zwt.png')" alt="" class="success-img">
      <div class="success-title">
        <div class="text">恭喜你，提交成功！</div>
        <div class="text">信息审核中</div>
      </div>
      <div class="success-tips">
        <div class="text">如果通过审核，会有工作人员与您联系</div>
        <div class="text">审核通过后，即可接单</div>
      </div>
    </div>
    <div class="footer-btn">
      <van-button
        round block
        type="info"
        native-type="submit"
        class="form-submit"
        @click="reAuth"
      >
        重新认证
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'success',
  methods: {
    reAuth() {
      this.$emit('reAuth')
    }
  }
}
</script>

<style lang="scss" scoped>
  .success-box {
    padding: rem(92) rem(136) 0 rem(136);
    text-align: center;
    .success-img {
      display: inline-block;
      width: rem(386);
      height: rem(324);
      margin-bottom: rem(64);
    }
    .success-title {
      line-height: rem(32);
      color: #333;
      font-size: rem(32);
      text-align: center;
      margin-bottom: rem(32);
      .text {
        margin-bottom: rem(10);
      }
    }
    .success-tips {
      line-height: rem(38);
      color: #666;
      font-size: rem(28);
      text-align: center;
    }
  }
  .footer-btn {
    position: fixed;
    left: rem(32);
    bottom: rem(32);
    right: rem(32);
    .form-submit {
      background: linear-gradient(90deg, #FF5D5D 0%, #D82626 100%);
      width: 100%;
      border-radius: rem(16);
      border: none;
      .van-button__text {
        font-size: rem(32);
        font-family: 'Source Han Sans CN';
        font-weight: 700;
      }
    }
  }
</style>
